import { render, staticRenderFns } from "./ScreeningResultsSimilarity.vue?vue&type=template&id=24254c0f"
import script from "./ScreeningResultsSimilarity.vue?vue&type=script&lang=js"
export * from "./ScreeningResultsSimilarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports